import { FormBuilder } from '../../components/FormBuilder/FormBuilder'
import { generateColumnDefsFromModel } from '../../components/WebbaDataTable/utils'
import formsModel from '../../../schemas/forms.json'
import { createFormFromModel } from '../../components/Form/lib/createForm'
import {
    createFormMenuSectionsFromModel,
    safeParse,
} from '../../components/Form/utils/utils'
import { useDispatch, useSelect } from '@wordpress/data'
import { store, store_name } from '../../../store/backend'
import { useSidebar } from '../../components/Sidebar/SidebarContext'
import { useWbkTable } from '../../components/WebbaDataTable/hooks/useWbkTable'
import { getCellActions } from '../../components/WebbaDataTable/helpers/getCellActions'
import { Menu } from '../../components/WebbaDataTable/Menu'
import { Form } from '../../components/Form/Form'
import { __ } from '@wordpress/i18n'
import { Table } from '../../components/WebbaDataTable/Table'

const columns = generateColumnDefsFromModel(formsModel)

const form = createFormFromModel(formsModel)

const formSections = createFormMenuSectionsFromModel({
    model: formsModel,
    form,
    modelName: 'forms',
})

export const FormBuilderScreen = () => {
    const { deleteItems, addItem } = useDispatch(store)
    const sidebar = useSidebar()

    const { forms, isLoading } = useSelect(
        (select) => ({
            forms: select(store).getItems('forms'),
            isLoading: select(store).getLoading(),
        }),
        []
    )

    const { plugin_url, settings } = useSelect(
        // @ts-ignore
        (select) => select(store_name).getPreset(),
        []
    )

    const table = useWbkTable({
        columns,
        data: forms,
        selectable: true,
        isAdmin: settings?.is_admin,
        renderMenu: ({ cell }) => {
            const { onDelete, onDuplicate, onSubmit } = getCellActions({
                cell,
                collectionName: 'forms',
            })

            return (
                <Menu
                    onDelete={onDelete}
                    onDuplicate={onDuplicate}
                    onEdit={() => {
                        const { value } = safeParse(cell.row.original.fields)

                        if (value) {
                            sidebar.open(
                                <FormBuilder
                                    onSave={(data) => {
                                        onSubmit({
                                            name: data.name,
                                            fields: JSON.stringify(data.fields),
                                        })
                                    }}
                                    initialState={{
                                        name: cell.row.original.name,
                                        fields: value,
                                    }}
                                    buttonTitle={__(
                                        'Save form',
                                        'webba-booking-lite'
                                    )}
                                />
                            )
                        }
                    }}
                />
            )
        },
    })

    const onDeleteSelected = async () => {
        const selectedRowsIds = table
            .getSelectedRowModel()
            .rows.map((row) => row.original.id)

        if (!selectedRowsIds.length) {
            return
        }

        await deleteItems('forms', selectedRowsIds)
    }

    const addModelItem = async (data: any) => {
        try {
            await addItem('forms', {
                name: data.name,
                fields: JSON.stringify(data.fields),
            })
        } catch (e) {
            console.error('failed to add form', e)
        }
    }

    return (
        <Table
            title={__('Booking forms', 'webba-booking-lite')}
            addButtonTitle={__('Add Form', 'webba-booking-lite')}
            table={table}
            loading={isLoading}
            onDeleteSelected={onDeleteSelected}
            onAdd={() =>
                sidebar.open(
                    <FormBuilder
                        onSave={addModelItem}
                        buttonTitle={__('Create form', 'webba-booking-lite')}
                    />
                )
            }
            noItemsImageUrl={plugin_url + '/public/images/bookings-empty.png'}
        />
    )
}
